/**
 * Water Fluid Properties Engine
 * Temperature-dependent density and viscosity based on NIST and Vogel formulations.
 */



export function getWaterProperties(temperatureC = 20) {
  const T = Math.max(0, Math.min(100, temperatureC));

  // Density formulation (kg/m3) accurate to within 0.1% between 0°C and 100°C
  const density = 1000 * (1 - ((T + 288.9414) / (508929.2 * (T + 68.12963))) * Math.pow(T - 3.9863, 2));

  // Dynamic Viscosity (Pa·s): Vogel equation for liquid water
  const T_kelvin = T + 273.15;
  const A = 2.414e-5; // Pa·s
  const B = 247.8;    // K
  const C = 140.0;    // K
  const dynamicViscosity = A * Math.pow(10, B / (T_kelvin - C));

  // Kinematic Viscosity nu = mu / rho (m2/s)
  const kinematicViscosity = dynamicViscosity / density;

  return {
    temperatureC: T,
    density: parseFloat(density.toFixed(2)),
    dynamicViscosity,
    kinematicViscosity,
  };
}
